import useSWR, { type SWRConfiguration } from "swr";
import type {
  GetIndividualGeoJsonQuery,
  IndividualsGeoJsonResponse,
} from "./type";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";

async function getIndividualsGeoJson(
  query?: GetIndividualGeoJsonQuery,
): Promise<IndividualsGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (isEmpty(value)) return;

      params.append(key, String(value));
    });
  }

  let url = apiPaths.individuals.getGeoJson;

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<IndividualsGeoJsonResponse>(url);

  return response.data;
}

export function useGetIndividualsGeoJson(
  query?: GetIndividualGeoJsonQuery,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    revalidateOnFocus: false,
    ...options,
  };

  return useSWR(
    enabled ? [`fetch-individuals-geojson`, JSON.stringify(query ?? {})] : null,
    () => getIndividualsGeoJson(query ?? {}),
    mergedOptions,
  );
}
